import React from "react";
import { View } from "@react-pdf/renderer";
import { styles } from "../styles";
import { ProductSizeQuantities } from "./ProductSizeQuantities";
import { ProductImage } from "./ProductImage";
import { ProductInfo } from "./ProductInfo";
import { Totals } from "./Totals";
import { translate } from "../translate";

export const ProductLineDetails = ({ order, product }) => (
  <View style={styles.row}>
    <View style={styles.productDetailsLeft}>
      <ProductImage url={product.image} />
    </View>
    <View style={styles.productDetailsRight}>
      <ProductSizeQuantities order={order} product={product} />
      <View style={styles.row}>
        <View style={styles.col50}>
          <ProductInfo info={product.info} />
        </View>
        <View style={styles.col50}>
          <Totals order={order} totals={product.totals} />
        </View>
      </View>
    </View>
    {!!product.comment && <View>{translate("comment")}</View>}
  </View>
);
